import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { useData } from "../context/DataContext";

export default function NoteDialog({ open, onClose, tenant }) {
  const { addTenantNote } = useData();
  const [text, setText] = useState("");

  useEffect(() => {
    if (open) setText("");
  }, [open]);

  if (!tenant) return null;

  const submit = (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    addTenantNote(tenant.id, text);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Add note"
      description={`${tenant.name} · House ${tenant.houseNumber}`}
    >
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="label-base">Note</label>
          <textarea
            className="input-base min-h-[120px] resize-y"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="e.g. Will pay on the 23rd"
            required
            autoFocus
          />
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Notes are saved to the tenant's history with a timestamp.
          </p>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" className="btn-primary">Save note</button>
        </div>
      </form>
    </Modal>
  );
}
